<template>
    <div class="px-0 pb-0 card-body">
        <div class="table-responsive">
            <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns">
                <div class="dataTable-container">
                    <table id="genericTable" ref="genericTable" class="table table-flush dataTable-table">
                        <thead class="thead-light">
                            <GenericTableHeaderV2 :headers="headers" :list-filters="listFilters" @changed-header="changedHeader" />
                        </thead>
                        <tbody v-if="isLoading">
                            <tr>
                                <td :colspan="headers.length" class="text-center py-5">
                                    <i class="fa-solid fa-spinner fa-spin me-2"></i>
                                        {{ $t('key_table_loading_results') }}
                                    </td>
                                </tr>
                            </tbody>
                        <tbody v-else-if="items.length > 0" ref="genericTableBody">
                            <tr v-for="(item) of items" :key="item._id">
                                <slot name="row" v-bind="{item, isChecked: selectedIds.includes(item._id), changedSelection: () => changedItemSelection(item._id)}">
                                </slot>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td :colspan="headers.length" class="text-center py-5 text-muted">
                                    <i class="fa-solid fa-circle-xmark fa-lg me-2"></i>
                                    {{ $t('key_table_no_results') }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer border-0 pt-0">
        <div v-if="isLoading" class="text-center text-muted py-3">
            <i class="fa-solid fa-loading fa-lg me-2"></i>
            {{ $t('key_table_waiting_results') }}
        </div>
        <div v-if="!isLoading && pagination.total > 0" class="d-flex flex-column flex-lg-row align-items-center justify-content-between gap-3">
            <EntriesPerPage :current="pagination.rows" @change="changedRow" />

            <PagerInformation :total="pagination.total" :current="pagination.currentPage" :rows="pagination.rows" />
            
            <Pager :total="totalPages" :current="pagination.currentPage" @changed-page="changedPage" />
        </div>
    </div>
</template>

<script>

    import GenericTableHeaderV2 from "./GenericTableHeaderV2";
    import Pager from "./Pager.vue";
    import PagerInformation from "./PagerInformation.vue";
    import EntriesPerPage from "./EntriesPerPage.vue";

    export default {
        name: "GenericTable",
        components: {
            EntriesPerPage,
            GenericTableHeaderV2,
            Pager,
            PagerInformation
        },
        props: {
            listFilters: {
                type: Object,
                default: null,
            },
            items: {
                type: Array,
                default: () => [],
            },
            pagination: {
                type: Object,
                default: () => ({
                    total: 200,
                    rows: 10,
                    currentPage: 1,
                    pages: {
                        total: 10,
                        current: 1,
                    },
                    entries: [5, 10, 15, 20, 50, 100, 200]
                })
            },
            enablePagination: {
                type: Boolean,
                default: true
            },
            headers: {
                type: Array,
                default: () => [
                    {
                        title: "",
                        sort: false,
                    }
                ]
            },
            selectedIds: {
                type: Array,
                default: () => []
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        emits: ['changed-page', 'changed-row', 'changed-header', 'changed-selection'],
        computed: {
            totalPages() {
                return Math.ceil(this.pagination.total / this.pagination.rows);
            }
        },
        watch: {
            items() {
                let table = this.$refs.genericTable
                table.classList.remove('loading')
            }
        },
        methods: {
            changedPage(index) {
                this.$emit('changed-page', index);
            },
            changedHeader(val) {
                this.$emit('changed-header', val);
            },
            changedRow(val) {
                this.$emit('changed-row', val);
            },
            changedItemSelection(id) {
                this.$emit('changed-selection', id);
            },
            isItemSelected(id) {
                return this.selectedIds.includes(id);
            }
        }
    }

</script>

<style scoped>

    .loading-animation {
        position: relative;
        opacity: 0.5;
        transition: opacity 0.5s ease-in-out;
    }

    .loading-animation:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.8);
        z-index: 2;
        background-image: url('../../assets/img/spinner2.gif');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 50px 50px;
    }

    .column {
        flex-grow: 1;
        padding: 0px;
    }

    .left {
        position: relative;
        display: flex;
        justify-content: flex-start;
    }

    .center {
        display: flex;
        justify-content: center;
    }

    .right {
        display: flex;
        justify-content: flex-end;
    }

    .overflow-aux {
        overflow: visible !important;
    }

</style>